module.exports = __webpack_public_path__ + "img/pierre_d.1ef95899.png";